import { render, staticRenderFns } from "./AddProjectTeamMember.vue?vue&type=template&id=677507c0"
import script from "./AddProjectTeamMember.vue?vue&type=script&lang=js"
export * from "./AddProjectTeamMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports